import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faSort,
  faSortUp,
  faSortDown,
  faWrench,
  faGripVertical,
  faDownload,
  faFileExport,
  faSearch,
  faBars,
  faCloudDownloadAlt,
  faTimes,
  faCheck,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faQuoteRight,
  faCode,
  faListUl,
  faListOl,
  faOutdent,
  faIndent,
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
  faAlignJustify,
  faLink,
  faRemoveFormat,
  faTasks,
  faParagraph,
  faTrashRestore,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faShareAlt,
  faExternalLinkAlt,
  faAngleUp,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faEllipsisH,
  faEyeSlash,
  faArrowRight,
  faFilter,
  faUserCog,
  faGripHorizontal,
  faCogs,
  faPen,
  faThumbtack,
  faPlus,
  faColumns,
  faSearchLocation,
  faMapMarkedAlt,
  faKey,
  faQuestion,
} from '@fortawesome/free-solid-svg-icons'

import {
  faEye,
  faFileAlt,
  faFileWord,
  faFilePdf,
  faFilePowerpoint,
  faFileArchive,
  faFileExcel,
  faFileVideo,
  faFileImage,
  faEdit,
  faTrashAlt,
  faBell,
  faClock,
  faSquare,
  faClone,
  faPlusSquare,
  faEnvelope,
  faQuestionCircle,
  faSave,
  faUser,
} from '@fortawesome/free-regular-svg-icons'

library.add(
  faSort,
  faSortUp,
  faSortDown,
  faWrench,
  faGripVertical,
  faDownload,
  faFileAlt,
  faFileWord,
  faFilePdf,
  faFilePowerpoint,
  faFileArchive,
  faFileExcel,
  faFileVideo,
  faFileImage,
  faFileExport,
  faEdit,
  faTrashAlt,
  faSearch,
  faBars,
  faCloudDownloadAlt,
  faTimes,
  faCheck,
  faBell,
  faClock,
  faSquare,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faQuoteRight,
  faCode,
  faListUl,
  faListOl,
  faOutdent,
  faIndent,
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
  faAlignJustify,
  faLink,
  faRemoveFormat,
  faTasks,
  faParagraph,
  faClone,
  faPlusSquare,
  faTrashRestore,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faShareAlt,
  faEnvelope,
  faAngleUp,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faExternalLinkAlt,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faEllipsisH,
  faEyeSlash,
  faArrowRight,
  faUserCog,
  faQuestionCircle,
  faFilter,
  faSave,
  faGripHorizontal,
  faUser,
  faCogs,
  faPen,
  faThumbtack,
  faEye,
  faPlus,
  faColumns,
  faSearchLocation,
  faMapMarkedAlt,
  faKey,
  faQuestion,
)
